/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {
  document
  .querySelectorAll('.dropdown__family--grandchild .navlink--grandchild .navtext')
  .forEach(el => {
    if (el.textContent.trim() === 'Les Thermes de Saint-Gervais Mont Blanc' || el.textContent.trim() === 'Vos questions ? Nos réponses !' || el.textContent.trim() === 'Beurre de karité' || el.textContent.trim() === 'Nos points de vente' || el.textContent.trim() === 'Profitez de -20% sur une sélection de produits') {
      el.parentNode.classList.add('nav-text-undefined');
    }
  });

  document.querySelectorAll('.dropdown__family.dropdown__family--grandchild').forEach(el => {
    const span = el.querySelector('span.navtext');
    if (span && span.textContent.trim() === 'DÉCOUVREZ NOS OFFRES') {
      el.style.opacity = '0';
      el.style.pointerEvents = 'none'; // évite les clics sur une zone invisible
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.sliderule__wrapper').forEach(wrapper => {
      const titleEl = wrapper.querySelector('.sliderow__title');
      if (titleEl && titleEl.textContent.trim() === 'DÉCOUVREZ NOS OFFRES') {
        wrapper.style.display = 'none';
      }
    });
  });
})();